import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXSelectField from "../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import BMXDatePicker from "../../../../../Components/Inputs/BMXDatePicker/BMXDatePicker";
import { updateDashboardByName } from "../../../../../Utils/Sockets";
import { show } from "redux-modal";
import { useDispatch } from "react-redux";
import BMXAsynchronous from "../../../../../Components/Inputs/BMXAsynchronous/BMXAsynchronous";

const LeasingFormStepTwo = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [leasingTypeSelect, setLeasingTypeSelect] = useState([]);

  // NEW COMPONENET
  const [contacts, setContacts] = useState([]);
  const REGISTRY_NAME = "contact";

  const { values, form } = props;

  useEffect(() => {
    // LOADING DICTIONARIS
    const fetchData = async () => {
      const leasingTypeFetch = GlobalAuthFetch({
        path: "/dictionary/leasingType/fieldName",
      });

      const [leasingTypePayload] = await Promise.all([leasingTypeFetch]);

      setLeasingTypeSelect(
        leasingTypePayload?.payload?.data?.dictionaryEntries
      );
    };
    fetchData();
  }, []);

  return (
    <div style={{ justifyContent: "flex-start" }}>
      {/* <BMXSeparator title={t("global:leasing.basicInformation")} /> */}
      <Row>
        <Col xs={6}>
          <Field
            component={BMXDatePicker}
            label={`${t("global:leasing.startDate")}*`}
            name="startDate"
            data-cy="startDate"
          />
        </Col>
        <Col xs={6}>
          <Field
            component={BMXDatePicker}
            label={`${t("global:leasing.endDate")}*`}
            name="endDate"
            data-cy="endDate"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={3}>
          <Field
            name="netWorthBefore"
            label={`${t("global:leasing.netWorthBefore")}`}
            component={BMXTextField}
            type="money"
            decimalScale={2}
            data-cy="netWorthBefore"
            defaultValue={"0.00"}
          />
        </Col>
        <Col xs={3}>
          <Field
            name="monthWorth"
            label={`${t("global:leasing.monthWorth")}`}
            component={BMXTextField}
            type="money"
            decimalScale={2}
            defaultValue={"0.00"}
            data-cy="monthWorth"
          />
        </Col>
        <Col xs={3}>
          <Field
            name="estimatedInstallment"
            label={`${t("global:leasing.estimatedInstallment")}`}
            component={BMXTextField}
            type="money"
            decimalScale={2}
            defaultValue={"0.00"}
            data-cy="estimatedInstallment"
          />
        </Col>
        <Col xs={3}>
          <Field
            name="nettoBuyout"
            label={`${t("global:leasing.nettoBuyout")}`}
            component={BMXTextField}
            type="money"
            decimalScale={2}
            defaultValue={"0.00"}
            data-cy="nettoBuyout"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Field
            component={BMXTextField}
            label={`${t("global:leasing.otherCosts")}`}
            name="otherCosts"
            data-cy="otherCosts"
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <Field
            component={BMXTextField}
            label={`${t("global:offer.comments")}*`}
            name="comments"
            data-cy="comments"
          />
        </Col>
      </Row>
    </div>
  );
};

export default LeasingFormStepTwo;
